// Cliente da API do gateway. Token JWT (Strapi) em sessionStorage.

const TOKEN_KEY = 'sp_diag_jwt';

export const getToken = (): string | null => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t: string): void => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = (): void => sessionStorage.removeItem(TOKEN_KEY);

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export interface OperadoraMeta {
  id: string;
  nome: string;
  logo: string;
  cor?: string;
  maskedId: string;
}

export interface OperadoraPayload {
  id: string;
  maskedId?: string;
  data: any;
  headerImageUrl: string;
  dataPeriodoNovo?: any;
}

async function authedGet(path: string): Promise<any> {
  const token = getToken();
  const res = await fetch(path, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (res.status === 401) {
    clearToken();
    throw new ApiError('Sessão expirada. Faça login novamente.', 401);
  }
  if (!res.ok) {
    let msg = 'Erro ao carregar dados.';
    try {
      msg = (await res.json()).error || msg;
    } catch {
      /* corpo não-JSON */
    }
    throw new ApiError(msg, res.status);
  }
  return res.json();
}

export async function login(identifier: string, password: string): Promise<void> {
  const res = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ identifier, password }),
  });
  if (!res.ok) {
    let msg = 'Credenciais inválidas.';
    try {
      msg = (await res.json()).error || msg;
    } catch {
      /* corpo não-JSON */
    }
    throw new ApiError(msg, res.status);
  }
  const j = await res.json();
  if (!j.jwt) throw new ApiError('Resposta inválida do servidor.', 500);
  setToken(j.jwt);
}

export const getOperadoras = (): Promise<OperadoraMeta[]> => authedGet('/api/operadoras');

export const getOperadora = (id: string): Promise<OperadoraPayload> =>
  authedGet(`/api/operadoras/${encodeURIComponent(id)}`);
